module.exports = __webpack_public_path__ + "assets/9a51a38ebd747a5de75ebd885868cb50.svg";